import React from 'react'
import { Grid, Typography, Button, Box } from '@mui/material'

import { CustomTableData, LinearLoading } from 'common'
import { DollarSign, List } from 'react-feather'

export const PaymentExemptionSection = ({ useFetchInit }) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal
    
    // ------------------------------------------------ FetchData
    const { fetchPaymentsToBeExempted } = FetchData
    const { loadingFetchPaymentsToBeExempted } = fetchPaymentsToBeExempted
    
    // ------------------------------------------------ Actions
    const { 
        handleClickOpenPaymentExemptionModal,
        handleClickLoadPayments
    } = Actions


    const columnConfig = [
        { 
            field: "info_tipo", 
            headerName: "TIPO", 
            minWidth: 160,
            maxWidth: 160,
            filter: true ,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {
                return params.value === 'ORDINARIO' ? 'bg-info' : 'bg-warning';
            },
            cellRenderer: (params) => {
                const { value } = params
                return(
                    
                    (value ==='ORDINARIO') ? 
                            <span><i className="fa-solid fa-circle-check"></i> ORDINARIO</span>
                        : 
                            <span><i className="fa-solid fa-circle-exclamation"></i> EXTRAORDINARIO </span>
                )
            }
        },
        { field: "info_fecha_pago", headerName: "FECHA PAGAR", minWidth: 140, filter: true},
        { field: "info_costo_alquiler", headerName: "ALQUILER (Q)", minWidth: 140, filter: true},
        { 
            field: "info_exoneracion", headerName: "EXONERACIÓN (Q)", minWidth: 180, filter: true,
            cellClass: (params) => {
                return parseFloat(params.data.info_exoneracion) !== 0 ? 'bg-secondary bg-gradient text-white' : '';
            },
        },
        { 
            field: "total_cancelar", headerName: "CANCELAR (Q)", minWidth: 150, filter: true,
            cellClass: (params) => {
                return params.data.info_tipo === 'ORDINARIO' ? 'bg-warning' : 'bg-primary';
            },
        },
        { field: "total_recibido", headerName: "RECIBIDO (Q)", minWidth: 140, filter: true },
        { 
            field: "total_saldo", headerName: "SALDO (Q)", minWidth: 140, filter: true,
            cellClass: (params) => {
                return parseFloat(params.value) !== 0 ? 'bg-danger' : 'bg-success';
            }
        },
        {
            headerName: "MODO EXONERACION",
            minWidth: 400,
            cellRenderer: (params) => {
                const {total_saldo, total_cancelar, isPaid} = params.data
                return(
                    <>
                        <Button 
                            startIcon = { <DollarSign/>}
                            variant='contained'
                            size='small' 
                            sx={{ marginRight: '8px' }}
                            onClick={
                                () => handleClickOpenPaymentExemptionModal(
                                    '',
                                    `REGISTRAR MONTO A EXONERAR, MONTO A CANCELAR: Q ${total_cancelar}`,
                                    'PaymentExemption', 
                                    { data: params.data },
                                    'EDITABLE'
                                )
                            }
                            style={ { 
                                width: 170,
                                background: (parseFloat(total_saldo) === 0) ? '#7ca2b4' : '#21130d'
                            }}
                            disabled={
                                ( (parseFloat(total_saldo) === 0) && (isPaid === 'SI')) ? true : false
                            }
                        >
                            EXONERAR
                        </Button>
                    </>
                    
                )
            }
        },
    ]
    
    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Box pt={4}>
                <Grid container spacing={2} justifyContent="flex-end">
                    <Grid item>
                        <Button 
                            startIcon = { <List/>}
                            variant='contained'
                            size='small'
                            color='success'
                            sx={{ marginRight: '8px' }}
                            onClick={()=>handleClickLoadPayments({formStateDetailsName: 'paymentExemptionDetails'})}
                            disabled={false}
                        >
                            Ver pagos
                        </Button>
                    </Grid>
                    
                </Grid>
            </Box>
            
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    {(loadingFetchPaymentsToBeExempted)&& (<LinearLoading/>)}
                    <CustomTableData 
                        rowConfig={formState.paymentExemptionDetails}
                        columnConfig={columnConfig}
                    />
                </Grid> 
            </Grid>
        </>
    )
}
